import i18n from "i18next"
import detector from "i18next-browser-languagedetector"
import { initReactI18next } from "react-i18next"
import i18next from "i18next"


import translationFR from "./fr/translation.json"
import translationENG from "./eng/translation.json"

import usFlag from '../assets/images/flags/us.jpg'
import frFlag from '../assets/images/flags/french.jpg'



// the translations
const resources = {
  fr_FR: {
    translation: translationFR,
  },
  en_EN: {
    translation: translationENG,
  },
}

export const languages = {
  en_EN: {
    label: 'en_EN',
    flag: usFlag,
  },
  fr_FR: {
    label: 'fr_FR',
    flag: frFlag,
  },
}

i18n
  .use(detector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: localStorage.getItem("i18nextLng") || "fr_FR",

    keySeparator: false, // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  })

export default i18n
